import DashboardLayout from '@/pages/Layout/DashboardLayout.vue'

import Dashboard from '@/pages/Dashboard.vue'

import Packages from '@/pages/Packages.vue'
import PackagesView from '@/pages/Packages/View.vue'
import PackagesDetail from '@/pages/Packages/Detail.vue'
import PackagesEdit from '@/pages/Packages/Edit.vue'
import PackagesNew from '@/pages/Packages/New.vue'

import ErrorPackages from '@/pages/ErrorPackages.vue'
import ErrorPackagesView from '@/pages/ErrorPackages/View.vue'

import Settings from '@/pages/Settings.vue'
import SettingsView from '@/pages/Settings/View.vue'

import Zones from '@/pages/Zones.vue'
import ZonesView from '@/pages/Zones/View.vue'
import ZonesEdit from '@/pages/Zones/Edit.vue'

import Clients from '@/pages/Clients.vue'
import ClientsView from '@/pages/Clients/View.vue'
import ClientsEdit from '@/pages/Clients/Edit.vue'
import ClientsDetail from '@/pages/Clients/Detail.vue'

import Referral from '@/pages/Referral.vue'
import ReferralView from '@/pages/Referral/View.vue'
import ReferralEdit from '@/pages/Referral/Edit.vue'
import ReferralDetail from '@/pages/Referral/Detail.vue'

import Payments from '@/pages/Payments.vue'
import PaymentsView from '@/pages/Payments/View.vue'
import PaymentsDetail from '@/pages/Payments/Detail.vue'

import Drivers from '@/pages/Drivers.vue'
import DriversView from '@/pages/Drivers/View.vue'
import DriversEdit from '@/pages/Drivers/Edit.vue'
import DriversDetail from '@/pages/Drivers/Detail.vue'

import Stats from '@/pages/Stats.vue'
import StatsView from '@/pages/Stats/View.vue'

import NewPackage from '@/pages/NewPackage.vue'
import PrintPayment from '@/pages/PrintPayment.vue'
import PrintPaymentDriver from '@/pages/PrintPaymentDriver.vue'
import PrintPaymentDriverPickup from '@/pages/PrintPaymentDriverPickup.vue'
import PrintPaymentReferral from '@/pages/PrintPaymentReferral.vue'

import Transactions from '@/pages/Transactions.vue'
import TransactionsView from '@/pages/Transactions/View.vue'
import TransactionsDetail from '@/pages/Transactions/Detail.vue'

import Administrators from '@/pages/Administrators.vue'
import AdministratorsView from '@/pages/Administrators/View.vue'
import AdministratorsEdit from '@/pages/Administrators/Edit.vue'

import DriverPackages from '@/pages/DriverPackages.vue'
import DriverPackagesView from '@/pages/DriverPackages/View.vue'
import DriverPackagesDetail from '@/pages/DriverPackages/Detail.vue'

const routes = [
	{
		path: '/',
		component: DashboardLayout,
		redirect: '/dashboard',
		children: [
			{
				path: 'dashboard',
				name: 'ផ្ទាំងទាំងអស់',
				component: Dashboard
			},
			{
				path: 'settings',
				component: Settings,
				children: [
					{
						path: '',
						name: "Settings",
						component: SettingsView
					}
				]
			},
			{
				path: 'zones',
				component: Zones,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងតំបន់ និងទីតាំងដឹកជញ្ជូន",
						component: ZonesView
					},
					{
						path: 'edit/:id',
						name: "ការគ្រប់គ្រងតំបន់ និងទីតាំងដឹកជញ្ជូន",
						component: ZonesEdit
					}
				]
			},
			{
				path: 'drivers',
				component: Drivers,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងអ្នកដឹកជញ្ជូន",
						component: DriversView
					},
					{
						path: 'edit/:hash_id',
						name: "ការគ្រប់គ្រងអ្នកដឹកជញ្ជូន",
						component: DriversEdit
					},
					{
						path: 'detail/:hash_id',
						name: "ការគ្រប់គ្រងអ្នកដឹកជញ្ជូន",
						component: DriversDetail
					}
				]
			},
			{
				path: 'transactions',
				component: Transactions,
				children: [
					{
						path: '',
						name: "ប្រវត្តិប្រតិបត្តិការ",
						component: TransactionsView
					},
					{
						path: 'detail/:type/:hash_id',
						name: "ប្រវត្តិប្រតិបត្តិការ",
						component: TransactionsDetail
					}
				]
			},
			{
				path: 'new_package',
				name: "បង្កើតកញ្ចប់ឥវ៉ាន់ថ្មី",
				component: NewPackage,
			},
			{
				path: 'packages',
				component: Packages,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងកញ្ចប់ឥវ៉ាន់",
						component: PackagesView
					},
					{
						path: 'detail/:hash_id',
						name: 'ការគ្រប់គ្រងកញ្ចប់ឥវ៉ាន់',
						component: PackagesDetail
					},
					{
						path: 'edit/:hash_id',
						name: 'ការគ្រប់គ្រងកញ្ចប់ឥវ៉ាន់',
						component: PackagesEdit
					}
				]
			},
			{
				path: 'error_packages',
				component: ErrorPackages,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងកញ្ចប់ឥវ៉ាន់មានបញ្ហា",
						component: ErrorPackagesView
					}
				]
			},
			{
				path: 'driver_packages',
				component: DriverPackages,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងកញ្ចប់ឥវ៉ាន់",
						component: DriverPackagesView
					},
					{
						path: 'detail/:hash_id',
						name: 'ការគ្រប់គ្រងកញ្ចប់ឥវ៉ាន់',
						component: DriverPackagesDetail
					}
				]
			},
			{
				path: 'clients',
				component: Clients,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsView
					},
					{
						path: 'detail/:hash_id',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsDetail
					},
					{
						path: 'edit/:hash_id',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsEdit
					}
				]
			},
			{
				path: 'referral',
				component: Referral,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងអ្នកទីផ្សា",
						component: ReferralView
					},
					{
						path: 'detail/:hash_id',
						name: "ការគ្រប់គ្រងអ្នកទីផ្សា",
						component: ReferralDetail
					},
					{
						path: 'edit/:hash_id',
						name: "ការគ្រប់គ្រងអ្នកទីផ្សា",
						component: ReferralEdit
					}
				]
			},
			{
				path: 'payments',
				component: Payments,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងបង់ប្រាក់",
						component: PaymentsView
					},
					{
						path: 'detail/:hash_id',
						name: "ការគ្រប់គ្រងបង់ប្រាក់",
						component: PaymentsDetail
					}
				]
			},
			{
				path: 'stats',
				component: Stats,
				children: [
					{
						path: '',
						name: "ទិន្នន័យស្ថិតិ",
						component: StatsView
					}
				]
			},
			{
				path: 'administrators',
				component: Administrators,
				children: [
					{
						path: '',
						name: "Administrators",
						component: AdministratorsView
					},
					{
						path: 'edit/:id',
						name: 'Administrators',
						component: AdministratorsEdit
					}
				]
			}
		]
	},
	{
		path: '/print_payment/:hash_id',
		component: PrintPayment
	},
	{
		path: '/print_payment_driver',
		component: PrintPaymentDriver
	},
	{
		path: '/print_payment_driver_pickup',
		component: PrintPaymentDriverPickup
	},
	{
		path: '/print_payment_referral',
		component: PrintPaymentReferral
	}
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js